import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): PhotoState => {
  return {
    endWorkoutPhoto: null,
  };
};

const photo = (state = getInitialState(), action: ActionTypes): PhotoState => {
  switch (action.type) {
    case TypeKeys.SET_PHOTO_END_WORKOUT: {
      return {
        ...state,
        endWorkoutPhoto: action.photo,
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
  }
  return state;
};

export default photo;
